export default __webpack_public_path__ + "d80bbce75c60e7e7caad76f67a16ec8e.png";